import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { AuthService } from '../data-access/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@auto-editor/data-access-user';
import {
  LocalStorageKey,
  LocalStorageService
} from '@auto-editor/data-access-local-storage';
import { ToasterService } from '@auto-editor/feature-toaster';
import { DataQuestionnaireService } from '@auto-editor/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@auto-editor/environment';

@Component({
  selector: 'nx-ratenow-ui-login',
  templateUrl: './ui-login.component.html',
  styleUrl: './ui-login.component.scss',
  standalone: false
})
export class UiLoginComponent implements OnInit, OnDestroy {
  // formSignIn!: FormGroup;
  private destroy$ = new Subject<void>();
  // inputType = 'password';
  // visible = false;

  private localStorageKey = LocalStorageKey;

  // loggingSended = false;

  // @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(
  //   event: KeyboardEvent
  // ): void {
  //   event.preventDefault();
  //   if (this.formSignIn.valid) {
  //     this.send();
  //   }
  // }

  constructor(
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private router: Router,
    private userService: UserService,
    private localStorage: LocalStorageService,
    private toasterService: ToasterService,
    private dataQuestionnaireService: DataQuestionnaireService,
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // this.initForms();
    // this.fetchData();

    if (this.route.snapshot.queryParamMap.has('code')) {
      this.authService
        .getTokenByAuthorizationCode(
          this.route?.snapshot?.queryParamMap?.get('code'),
          window.location.origin + '/auth'
        )
        .pipe(
          switchMap(() => this.authService.getUserLogged()),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: (userLogged) => {
            // this.userFacade.updateUser(userLogged);
            this.userService.userInfo = userLogged;
            this.localStorage.saveData(
              this.localStorageKey.userLogged,
              JSON.stringify(userLogged)
            );
            if (!this.userService.userInfo.authorities.includes('access_all')) {
              this.localStorage.saveData(
                LocalStorageKey.clientSelected,
                JSON.stringify(userLogged.customerId)
              );
            }

            // this.rbacService.setAuthorities(userLogged.authorities);
            this.router.navigate(['/']);
            this.toasterService.success(
              this.translateService.instant('login.welcome')
            );
          },
          error: (error) => {
            if (error.status === 403 || error.status === 400) {
              this.userService.logOut();
              this.router.navigate(['/errors/403']);
            } else if (error.status === 500) {
              this.userService.logOut();
              this.router.navigate(['/errors/500']);
            } else {
              this.toasterService.error('login.error-login');
            }
          }
        });
    } else if (!this.authService.getOauthInfo()?.access_token) {
      const urlLogin =
        environment.logIn +
        `?response_type=code&client_id=${environment.apiClientId}&scope=${environment.scope}&redirect_uri=` +
        encodeURIComponent(window.location.origin + '/auth');

      window.location.href = urlLogin;
    } else {
      this.router.navigate(['/']);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // private initForms(): void {
  //   this.formSignIn = this.fb.group({
  //     username: ['', Validators.required],
  //     password: ['', Validators.required]
  //   });
  // }

  // private fetchData(): void {
  //   if (this.userService.userLoggedIn() && !this.loggingSended) {
  //     if(!this.userService.userInfo.authorities.includes('access_all')){
  //       this.localStorage.saveData(LocalStorageKey.clientSelected, JSON.stringify(this.userService.userInfo.customerId));
  //       this.router.navigate(['/']);
  //     }else{
  //       this.router.navigate(['/']);
  //     }
  //   }
  // }

  // send(): void {
    // this.loggingSended = true;
    // this.authService
    //   .login(this.formSignIn.value)
    //   .pipe(
    //     switchMap(() => this.authService.getUserLogged()),
    //     takeUntil(this.destroy$)
    //   )
    //   .subscribe({
    //     next: (userLogged) => {
    //       this.userService.userInfo = userLogged;
    //       this.localStorage.saveData(
    //         this.localStorageKey.userLogged,
    //         JSON.stringify(userLogged)
    //       );

    //       if (!this.userService.userInfo.authorities.includes('access_all')) {
    //         this.localStorage.saveData(
    //           LocalStorageKey.clientSelected,
    //           JSON.stringify(userLogged.customerId)
    //         );
    //       }

    //       // this.rbacService.setAuthorities(userLogged.authorities);
    //       this.router.navigate(['/']);
    //       this.toasterService.success(
    //         this.translateService.instant('login.welcome')
    //       );
    //     },
    //     error: () => {
    //       this.loggingSended = false;
    //       this.toasterService.error(
    //         this.translateService.instant('login.error')
    //       );
    //     }
    //   });
  // }

  // toggleVisibility(): void {
  //   this.visible = !this.visible;
  //   this.inputType = this.visible ? 'text' : 'password';
  //   this.cd.markForCheck();
  // }
}
